export default __webpack_public_path__ + "static/media/bgBlurProfit.1ef0dcea.png";